import { create } from "zustand";
import { persist } from "zustand/middleware";

import { SearchQueryRequestedPage } from "types/generated";
import { UsePaginationFetchMoreProps } from "components/Table/Pagination/types";

type IntentProjectsStore = {
  rowsPerPage: number;
  cursor: string | null;
  requestedPage: SearchQueryRequestedPage;
  onFetchItems: (props: UsePaginationFetchMoreProps) => void;
};

const useIntentProjectsStore = create<IntentProjectsStore>()(
  persist(
    (set) => ({
      rowsPerPage: 50,
      cursor: null,
      requestedPage: SearchQueryRequestedPage.First,
      onFetchItems: (props: UsePaginationFetchMoreProps) =>
        set({ cursor: props.cursor, requestedPage: props.requestedPage }),
    }),
    {
      name: "intent-projects-store",
      partialize: (state) => ({
        rowsPerPage: state.rowsPerPage,
      }),
    }
  )
);

export default useIntentProjectsStore;
